import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {getAll as getEpisodes} from "app/requests/admin/episodes";
import {create as createRecord} from "app/requests/admin/newsletters";
import {Loading} from "components/pages";
import {valueFrom, valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";
import usePrompt from "lib/hooks/use-prompt";
import {withoutBlankValues} from "lib/object";
import Form from "./form";

export default function AdminNewslettersNew() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const [block, setBlock] = useState(false);
  const [episodes, setEpisodes] = useState(null);
  const [record, setRecord] = useState({
    content: "",
    preview_text: "",
    subject: ""
  });

  usePrompt({when: block});
  useEffect(() => {
    getEpisodes().then((data) => setEpisodes(data.episodes));
  }, []);

  if(!episodes) { return <Loading />; }

  const onChange = ({target}) => {
    setBlock(true);
    setRecord({...record, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    setBlock(false);
    createRecord({newsletter: withoutBlankValues(record)}).then(({message, success}) => {
      if(success) {
        navigate("/admin/newsletters", {state: {message, type: "success"}});
      } else {
        dispatch(createNotification({content: message, type: "error"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({defaultValue, name, objects: [record]});

  return (
    <div className="container-fluid">
      <h1 className="text-center">New Newsletter</h1>
      <Form {...{episodes, onChange, onSubmit, value}} />
    </div>
  );
}
